const translationEn = {
  //lables
  GROUP: "Group",
  GROUPS: "Groups",
  NO_NOTIFICATION: "No Notification",
  TITLE: "Title",
  SEND: "Send",
  LOGIN: "Login",
  ENTER: "Enter",
  FORGOT_PASSWORD: "Forgot password?",
  ADVANCE_SEARCH: "Advance Search",
  SMART_SEARCH_BY: "Search by {{entity}} ...",
  NA: "-NA-",
  AND: "And",
  OR: "Or",
  BACK: "Back",
  TO: "To",
  FROM: "From",
  YOUR: "Your",
  CHANGE: "Change",
  RATE: "Rate",
  SETTINGS: "Settings",
  INTERVAL: "interval",
  RESCHEDULED: "Resheduled",
  PRIMARY: "Primary",
  VALUE: "Value",
  ITEM: "Item",
  CURRENT: "Current",
  DO: "Do",
  YOU: "You",
  WANT: "Want",
  REMARKS: "Remarks",
  COST: "Cost",
  ACTION: "Actions",
  NAME: "Name",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  USER_TYPE: "User Type",
  USER_ROLE: "User Role",
  EMAIL: "Email",
  EMPLOYEE_CODE: "Employee Code",
  DESIGNATION: "Designation",
  RECEIVE_NOTIFICATION: "Receive Notification",
  NOTIFICATION: "Notification",
  PHONE: "Phone",
  MOBILE: "Mobile",
  LANDLINE: "Landline",
  ADDRESS_MOBILE: "Address Mobile",
  PINCODE: "Pincode",
  STATUS: "Status",
  ROLE: "Role",
  ROLES: "Roles",
  COUNT: "Count",
  COUNTRY: "Country",
  COUNTRIES: "Countries",
  COUNTRY_CODE: "Country Code",
  STATE: "State",
  STATES: "States",
  CITY: "City",
  CITIES: "Cities",
  AREA: "Area",
  AREAS: "Areas",
  BUILDING: "Building",
  BUILDINGS: "Buildings",
  HOUSE_NO: "House No.",
  LANDMARK: "Landmark",
  CLEAR_FILTER: "Clear Filter",
  CLEAR: "Clear",
  SEARCH: "Search",
  USERNAME: "Username",
  IDENTIFIER: "Identifier",
  PASSWORD: "Password",
  OLD_PASSWORD: "Old Password",
  NEW_PASSWORD: "New Password",
  CONFIRM_PASSWORD: "Confirm Password",
  NEW: "New",
  OLD: "Old",
  CONFIRM: "Confirm",
  COMPANY: "Company",
  COMPANIES: "Companies",
  STORE: "Store",
  STORES: "Stores",
  IMAGE: "Image",
  MANAGER: "Manager",
  ADDRESS: "Address",
  PRIMARY_ADDRESS: "Primary Address",
  IS_DEFAULT: "Is Default",
  USER: "User",
  USERS: "Users",
  CUSTOMERS: "Customers",
  RETENTION: "Retention",
  NOT: "Not",
  ORDERED: "Ordered",
  ANY: "Any",
  SINCE: "Since",
  FOLLOWED: "Followed",
  UP: "Up",
  UPS: "Ups",
  NOTES: "Notes",
  GENDER: "Gender",
  MALE: "Male",
  FEMALE: "Female",
  TRANS_GENDER: "Other",
  FOLLOW: "Follow",
  FIRST: "First",
  LAST: "Last",
  PENDING: "Pending",
  TICKETS: "Tickets",
  CUSTOMER: "Customer",
  MAJOR: "Major",
  SHOW: "Show",
  HIDE: "Hide",
  AFTER: "After",
  DISC: "Disc.",
  VARIANCE: "Variance",
  CUSTOMER_NAME: "Customer Name",
  ASSIGNED_TO: "Assigned To",
  DETAILS: "Details",
  ASSIGNED: "Assigned",
  SERVED: "Served",
  SERVED_BY: "Served By",
  SERVICE_BY: "Service By",
  BY: "By",
  SERVICE: "Service",
  SERVICE_ITEMS_VALUE: "Service Items Value",
  STARTS: "Starts",
  WILL: "Will",
  TAKE: "Take",
  AROUND: "Around",
  ENDS: "Ends",
  AT: "At",
  TENTATIVE: "Tentative",
  RATING: "Rating",
  SERVICE_RATING: "Rating",
  ADDITIONAL: "Additional",
  DISCOUNT: "Discount",
  FINAL: "Final",
  PAYABLE: "Payable",
  ITEMS: "Items",
  AMOUNT: "Amount",
  ORDER_STATUS: "Status",
  ORDER_SERVE_AT: "Serve At",
  PROFESSION: "Profession",
  CREDENTIALS: "Credentials",
  OTHERS: "Others",
  ALTERNATE: "Alternate",
  PROFILE_PIC: "Profile Picture",
  HI: "Hi",
  THEME: "Theme",
  PROFILE: "Profile",
  CHOOSE_FILE: "Choose file",
  CHOOSE: "Choose",
  EXISTING: "Existing",
  UPLOAD: "Upload",
  PRODUCT: "Product",
  PRODUCTS: "Products",
  CODE: "Code",
  VIDEO: "Video",
  URL: "Url",
  SKU: "Sku",
  ORDER: "Order",
  ORDERS: "Orders",
  SERVE: "Serve",
  RESTORE: "Restore",
  LOGO: "Logo",
  CONTACT_PERSON: "Contact Person ",
  OWNER: "Owner ",
  CONTACT_PERSON_NAME: "Contact Person Name",
  CONTACT_PERSON_EMAIL: "Contact Person Email",
  CONTACT_PERSON_PHONE: "Contact Person Phone",
  CONTACT_PERSON1: "Contact Person 1",
  CONTACT_PERSON2: "Contact Person 2",
  TAX_NO: "Tax No.",
  TAX: "Tax",
  PAN_NO: "Pan No.",
  //action buttons
  LOADING: "Loading...",
  CREATE: "Create",
  UPDATE: "Update",
  EDIT: "Edit",
  VIEW: "View",
  LIST: "List",
  PUBLISH: "Publish",
  UNPUBLISH: "Unpublish",
  PUBLISHED: "Published",
  EXT: "Ext.",
  DELETE: "Delete",
  EXPORT: "Export All",
  IMPORT: "Import",
  IMPORTED: "Imported",
  ADD: "Add",
  ACTIVITY: "Activity",
  RANGE: "Range",
  MARK_PRIMARY: "Mark Primary",
  DETAIL: "Detail",
  DESCRIPTION: "Description",
  SOCIETY: "Society",
  CARE: "Care",
  SPECIAL: "Special",
  NOTE: "Note",
  ARE: "Are",
  OPEN: "Open",
  THIS: "This",
  SOURCE: "Source",
  CREATED: "Created",
  BIRTHDAY: "Birthday",
  ANNIVERSARY: "Anniversary",
  EXPECTED: "Expected",
  COMMENT: "Comment",
  EVENT: "Event",
  MONTH: "Month",
  WEEK: "Week",
  FOLLOWUP: "Follow Up",
  FOLLOWUPS: "Follow Ups",
  THERE: "There",
  HYGENIC: "Hygenic",
  FOOD: "Food",
  INDEX: "Index",
  SIZE: "Size",
  PROCESS: "Process",
  TIME: "Time",
  MINIMUM: "Minimum",
  QUANTITY: "Quantity",
  QTY: "Qty",
  AVAILABLE: "Available",
  ON: "On",
  DAY: "Day",
  CANCEL: "Cancel",
  CANCELLED: "Cancelled",
  CANCELLATION: "Cancellation",
  FEEDBACK: "Feedback",
  DATE: "Date",
  REASON: "Reason",
  RESET: "Reset",
  OVERALL: "Overall",
  ASSIGN: "Assign",
  FIND: "Find",
  TOTAL: "Total",
  MARK: "Mark",
  OK: "Ok",
  YES: "Yes",
  NO: "No",
  ACTIVE: "Active",
  INACTIVE: "InActive",
  CITY_NAME: "City Name",
  CITY_CODE: "City Code",
  PERMISSIONS: "Permissions",
  ROLE_PERMISSION: "Role Permission",
  ROLE_LIST: "Role List",
  FILTER: "Filter",
  HOME: "Home",
  HOUR: "Hour",
  TYPE: "Type",
  FINDER: "Finder",
  CATEGORY: "Category",
  PRICE: "Price",
  LABEL: "Label",
  BACKEND: "Backend",
  FRONTEND: "Frontend",
  SUPERADMIN: "Superadmin",
  CLIENT: "Client",
  ORDER_NO: "Order No",
  ALL: "All",
  SET: "Set",
  FOR: "For",
  NEXT: "Next",
  LIMITED: "Limited",
  IS_ASSIGNED: "Is Assigned",
  SHORT_CODE: "Short Code",
  LONG_CODE: "Long Code",
  STD_CODE: "Std Code",
  REGION: "Region",
  REGIONS: "Regions",
  CURRENCY: "Currency",
  STATE_LIST: "State List",
  SAVE: "Save",
  CLOSE: "Close",
  ADMIN: "Admin",
  REC: "Rec.",
  OF: "Of",
  FILE: "File",
  UPLOADED: "Uploaded",
  FAILED: "Failed",
  LENGTH: "Length",
  DATA: "Data",
  FORM: "Form",
  STEP1: "Step 1",
  STEP2: "Step 2",
  EXTRA: "Extra",
  UNASSIGNED: "Unassigned",
  MASTER: "Master",
  RULE: "Rule",
  ENABLE: "Enable",
  COMMERCIAL: "Commercial",
  PER: "Per",
  STANDARD: "Standard",
  VOLUME: "Volume",
  MUSIC: "Music",
  SLOTS: "Slots",
  STATE_NAME: "State Name",
  START: "Start",
  END: "End",
  SLOT: "Slot",
  CONTRACT: "Contract",
  CONTRACTS: "Contracts",
  BILLING: "Billing",
  FREQUENCY: "Frequency",
  PAYMENT: "Payment",
  PERIOD: "Period",
  BILL: "Bill",
  LICENSE: "License",
  AUTOMATE: "Automate",
  AUTOMATED: "Automated",
  AGREEMENT: "Agreement",
  NUMBER: "Number",
  INTERNAL: "Internal",
  BREAKUP: "Breakup",
  NATURE: "Nature",
  COMPETITOR: "Competitor",
  ORIGINAL: "Original",
  EMPLOYMENT: "Employment",
  SKILL: "Skill",
  EXTERNAL: "External",
  BENEFICIARY: "Beneficiary",
  MEMBER: "Member",
  RELATIVE: "Relative",
  ALLOWED: "Allowed",
  LICENSES: "Licenses",
  RELIGION: "Religion",
  WORK: "Work",
  OFF: "Off",
  JOINING: "Joining",
  RELIEVING: "Relieving",
  DEFAULT: "Default",
  MODE: "Mode",
  BOOKED: "Booked",
  AD: "Ad",
  FETCHING_DATA_OF: "Fetching {{field}}",
  DATA_FOUND_OF: "{{field}} found",
  NO_DATA_FOUND_OF: "No {{field}} found",
  FIELD_REQUIRED: "Field is required!",
  SELECT_COUNTRY: "Select Country",
  SELECT_STATE: "Select State",
  COMPANY_LOGO: "Company Logo",
  CHANGE_PASSWORD: "Change Password",
  PLAYER: "Player",
  STOP: "Stop",
  TODAY: "Today",
  UPCOMING: "Upcoming",
  PAST: "Past",
  SELECT: "Select",
  S_NO: "Sr. No.",
  REC_NO: "Rec No.",
  NETWORK: "Network",
  NO_RECORD_IMPORTED: "No Record Imported.",
  NO_RECORD_FOUND: "No Record Found.",
  IMPORTED_RECORDS: "Imported Records",
  FAILED_RECORDS: "Failed Records",
  //success messages
  CREATE_SUCCESS: "{{field}} created successfully.",
  UPDATE_SUCCESS: "{{field}} updated successfully.",
  PUBLISH_SUCCESS: "{{entity}} activated successfully.",
  UNPUBLISH_SUCCESS: "{{entity}} deactivated successfully.",
  LIST_SUCCESS: "{{entity}} listed successfully.",
  EXPORT_SUCCESS: "{{entity}} exported successfully.",
  IMPORT_SUCCESS: "{{entity}} imported successfully.",
  DELETE_SUCCESS: "{{entity}} deleted successfully.",
  MARK_PRIMARY_SUCCESS: "{{entity}} has been marked primary successfully.",
  FETCH_ERROR: "Error in fetching {{field}}.",
  CREATE_ERROR: "Error in creating {{field}}.",
  UPDATE_ERROR: "Error in updating {{field}}.",
  DELETE_ERROR: "Error in deleting {{field}}.",
  ASSIGN_SUCCESS: "{{field}} assigned successfully.",
  ASSIGN_ERROR: "Error in assigning {{field}}.",
  CHANGE_SETTING_NOTE: "Note: Any change in setting will reflect in next login",
  VALUE_TAKEN: "{{value}} value already taken",
  DATE2_SHALL_BE_GREATER_THAN_DATE1:
    "{{date2}} shall be greater than {{date1}}",
  DATE2_SHALL_BE_GREATER_THAN_EQUAL_DATE1:
    "{{date2}} shall be greater than equal to {{date1}}",

  //regular expression
  PASSWORD_PATTERN_REGEX:
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/,

  //validations
  USERNAME_VALIDATION: "Username with {{value}} already exist",
  DETECT_WHITESPACE: "{{field}} should not contain white space",
  PASSWORD_PATTERN:
    "Contain atleast one lowercase letter, one uppercase letter,Be at least 8 characters in length, Have at least one numerical character (0-9),Have at least one special character (#?!@$%^&*)",
  VALID: "Please enter a valid {{entity}}.",
  REQUIRED: "Please fill {{field}} field.",
  REQUIRED_SELECT: "Please select {{field}} field.",
  NUMERIC: "Please fill valid numeric value for {{field}}.",
  DECIMAL: "Please fill valid decimal value for {{field}}.",
  ALPHA_NUMERIC: "Please fill valid alpha numeric value for {{field}}.",
  ALLOWED_SPECIAL_CHARS: "Only {{chars}} are allowed.",
  GREATER_THAN: "{{field}} value should be greater than {{value}}.",
  LESS_THAN: "{{field}} value should be lesser than {{value}}.",
  GREATER_THAN_EQUAL_TO:
    "{{field}} value should be greater than equal to {{value}}.",
  LESS_THAN_EQUAL_TO:
    "{{field}} value should be lesser than equal to {{value}}.",
  DOES_NOT_MATCH: "{{field1}} and {{field2}} do not match together.",

  CONFIRM_ACTION: "Are you sure to {{action}} selected {{entity}}?",
  CONFIRM_CONTRACT_ACTION:
    "Are you sure to {{action}} selected {{entity}}? Please Note that {{entity}} could only be published if current date lies between contract start and end date.",
  CONFIRM_ACTION_ALL: "Are you sure to {{action}} {{entity}}?",
  CONFIRM_ACTION_TITLE: "Please confirm {{action}}!",
  ORDER_TOTAL_VALUE:
    "Total value of orders for the selected parameters is {{value}}.",
  ORDER_TOTAL_TITLE: "Total value of order!",
  PLEASE_SELECT_RECORD_TO_ACTION:
    "Please select atleast one record to perform this action",
  PLEASE_SELECT: "Please select",
  PLEASE_SELECT_FIELD: "Please select {{field}}",
  MATCH_PASSWORD: "Password and confirm password did not matched.",
  AT_LEAST: "{{field}} should contain atleast {{char}} character(s)",
  NO_PERMISSION: "You do not have permission to access the page",
  INVALID_ENTITY_ACCESS: "You do not have permission to access this {{entity}}",
  KEEP_SAME_ADDRESS_AS: "Keep same address as {{entity}} address",
  NOTE_PRODUCT_EMPTY_PRICE:
    "Note: Prodcuts {{product}} are having empty prices.",
};

export default translationEn;
